import React, { useContext } from 'react';
import { IconButton, Tooltip, Badge } from '@mui/material';
import { LearningContext } from '@/contexts/LearningContext';
import { HugeiconsIcon } from '@hugeicons/react';
import { Mortarboard02Icon } from '@hugeicons/core-free-icons';

const LearningHeaderButton: React.FC = () => {
  const context = useContext(LearningContext);

  // If outside of provider
  if (!context) {
    return null;
  }


  return (
    <Tooltip title="Ver video tutorial para esta sección">
      <IconButton onClick={context.openDrawer} color="primary">
        <Badge color="secondary" variant="dot">
          <HugeiconsIcon icon={Mortarboard02Icon} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default LearningHeaderButton;
